export const LOAD_DISTRICT_DATA = "LOAD_DISTRICT_DATA";
export const LOAD_DISTRICT_DATA_BY_ID = "LOAD_DISTRICT_DATA_BY_ID";
export const HOVER_POI = "HOVER_POI";
